import { render, staticRenderFns } from "./materialSelection.vue?vue&type=template&id=74a48b7a&"
import script from "./materialSelection.vue?vue&type=script&lang=js&"
export * from "./materialSelection.vue?vue&type=script&lang=js&"
import style0 from "./materialSelection.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports